import { render, staticRenderFns } from "./storeStaffList.vue?vue&type=template&id=206a27eb&scoped=true"
import script from "./storeStaffList.vue?vue&type=script&lang=js"
export * from "./storeStaffList.vue?vue&type=script&lang=js"
import style0 from "./storeStaffList.vue?vue&type=style&index=0&id=206a27eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a27eb",
  null
  
)

export default component.exports